import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { Upload } from './upload/upload';
import * as firebase from 'firebase';

interface Employee {
    active: number;
    activityId: string;
    admissionDate: any;
    applyInCheckClock?: boolean;
    applyInPrompterReport?: boolean;
    applyInSupervisorReport?: boolean;
    carrierId: string;
    cIsForeign?: boolean;
    createdAt: any;
    departmentId?: string;
    email: string;
    cellPhone: string;
    extPhone: string;
    imageUrl: string;
    internalKey: number;
    lastName: string;
    name: string;
    password: string;
    roleId: string;
    salt: string;
    subsidiaryId: string;
    token: string;
    transportArrive: number;
    updatedAt: any;
    appliesBonus: boolean;
}

export interface EmployeeId extends Employee {
    jobId: string;
    id: string;
}

@Injectable()
export class EmployeeService {

    collection: string;
    collectionSubsidiary: string;
    collectionJob: string;
    collectionRole: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.EMPLOYEE_COLLECTION;
        this.collectionSubsidiary = Globals.SUBSIDIARY_COLLECTION;
        this.collectionJob = Globals.JOB_COLLECTION;
        this.collectionRole = Globals.ROLE_COLLECTION;
    }

    generateId(){
        return this.afs.createId();
    }
    postEmployee(employeeObject: any, id: string = '') {
        let employeeCollection: any = this.afs.collection(this.collection);

        return !id ? employeeCollection.add(employeeObject).then(function(docRef) {
            //console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            //console.error('Error adding document: ', error);
        }) : employeeCollection.doc(id).set(employeeObject);
    }

    getEmployees({deleted = false, onEmpty=undefined}={}) {
        let employeeCollection: any;
        if(deleted) employeeCollection = this.afs.collection(this.collection, ref => ref.orderBy('lastName', 'asc'));
        else employeeCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).orderBy('lastName', 'asc'));

        let employees: any = employeeCollection.snapshotChanges().map(actions => {
            if(!actions.length && onEmpty) onEmpty();
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Employee;

                const name = data.name;
                const lastName = data.lastName;
                const email = data.email;
                const admissionDate = data.admissionDate;
                const internalKey = data.internalKey;
                const transportArrive = data.transportArrive;
                const jobId = data.activityId;
                const departmentId = data.departmentId;
                const applyInCheckClock = data.applyInCheckClock;
                const applyInPrompterReport = data.applyInPrompterReport;
                const applyInSupervisorReport = data.applyInSupervisorReport;
                const carrierId = data.carrierId;
                const appliesBonus = !!data.appliesBonus;

                return { id$, id: id$, name, lastName, email, admissionDate, internalKey, transportArrive, jobId, departmentId,
                         applyInCheckClock, applyInPrompterReport, applyInSupervisorReport, carrierId, appliesBonus };
            });
        }).map(object => object);

        return employees;
    }

    getEmployee(id$: string) {
        let employeeDocument: any = this.afs.doc(this.collection + '/' + id$);

        let employee: any = employeeDocument.valueChanges();

        return employee.map(object => object);
    }

    getEmployeeData(employeeId: string) {
        let employeeDocument: any = this.afs.doc(this.collection + '/' + employeeId);

        let employee: any = employeeDocument.snapshotChanges().map(action => {
            const id = action.payload.id;

            const data = action.payload.data() as Employee;

            return { id, ...data };
        }).map(document => {
            const subsidiary = this.afs.doc(this.collectionSubsidiary + '/' + document.subsidiaryId).snapshotChanges().map(doc => {
                const data = doc.payload.data();
                const subsidiaryName = data.name;
                return { subsidiaryName };
            });

            const job = this.afs.doc(this.collectionJob + '/' + document.activityId).snapshotChanges().map(doc => {
                const data = doc.payload.data();
                const jobName = data.name;
                const baseSalary = data.baseSalary;
                return { jobName, baseSalary };
            });

            return Observable.combineLatest(subsidiary, job, (subsidiaryData, jobData) => {
                return {
                    subsidiary: subsidiaryData,
                    job: jobData
                };
            }).map(data => {
                return {
                    subsidiaryObj: data.subsidiary,
                    jobObj: data.job,
                    ...document
                };
            });
        }).mergeMap(object => Observable.combineLatest(object));

        return employee;
    }

    putEmployee(employeeObject: any, id$: string) {
        let employeeCollection: any = this.afs.collection(this.collection);

        return employeeCollection.doc(id$).update(employeeObject).then(function() {
            console.log('Document updated: ' + id$);
            //console.log('Document updated: ' + id$ + ` ${++window['updated']}/1822`);
            //if(window['updated'] == 1822) console.timeEnd('load');
        }).catch(function(error) {
            console.error('Error updating document: ' + id$, error);
        });
    }

    /*
    // Method to delete the register from DB
    delEmployee(id$: string) {
        this.employeeDocument = this.afs.doc(this.collection + '/' + id$);

        return this.employeeDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delEmployee(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        let employeeCollection: any = this.afs.collection(this.collection);

        return employeeCollection.doc(id$).update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    getEmployeesWithFolio() {
        let employeeCollection: any = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).where('internalKey', '>', 0));

        let employees: any = employeeCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Employee;

                const internalKey = data.internalKey;
                const name = data.name;
                const lastName = data.lastName;

                return { id$, internalKey, name, lastName };
            });
        }).map(object => object);

        return employees;
    }

    uploadImage(upload: Upload, id: string) {
      const imageName = `profilePic_${upload.file.name}`;
      const storageRef = firebase.storage().ref();
      const uploadTask = storageRef.child(`${this.collection}/${id}/${imageName}`).put(upload.file);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
        upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      }, (err) => {
        console.log('error al subir');
      }, () => {
        let imageUrl = uploadTask.snapshot.downloadURL;
        this.putEmployee({imageUrl, imageName}, id);
      });
    }
    convertUploadImage(upload: Upload, id: string){
        let reader = new FileReader();
        reader.onload = ({target: {result: url}}: any) => {
            console.log(url);
            let blob: any;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.onload = () => {
                blob = xhr.response;
                blob.name = upload.file.name;
                let file: File = <File> blob;
                var currentUpload: Upload = new Upload(file);
                this.uploadImage(currentUpload, id);
            };
            xhr.send();
        };
        reader.readAsDataURL(upload.file);
    }
    deleteImage(id: string, imageName: string){
      const storageRef = firebase.storage().ref();
      var imageToDeleteRef = storageRef.child(`${this.collection}/${id}/${imageName}`);
      imageToDeleteRef.delete();
      this.putEmployee({imageUrl: '', imageName: ''}, id);
    }
    uploadQR(upload: Upload, id: string){
      const imageName = `qrCode.png`;
      const storageRef = firebase.storage().ref();
      const uploadTask = storageRef.child(`${this.collection}/${id}/${imageName}`).put(upload.file);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
        upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      }, (err) => {
        console.log('error al subir');
      }, () => {
        let qrUrl = uploadTask.snapshot.downloadURL;
        this.putEmployee({qrUrl}, id);
      });
    }

    /* employees: DataEmployee[] = [
        new DataEmployee('Maria Ramona', 'Carrillo Carrillo', '2007-04-23', 170, 'TERMINADOS', 'AUXILIAR DE LINEA'),
        new DataEmployee('Socorro del Carmen', 'Valdivia Ortega', '2014-07-21', 281, 'TERMINADOS', 'AUXILIAR DE LINEA'),
        new DataEmployee('Rosalba Quintero', 'Dorado', '2011-08-22', 291, 'TERMINADOS', 'AUXILIAR DE LINEA'),
        new DataEmployee('Andrea Berenice', 'Camarena Moreno', '2014-09-22', 375, 'TERMINADOS', 'AUXILIAR DE LINEA'),
        new DataEmployee('Miguel Angel', 'Quintero Veloz', '2017-09-18', 465, 'TERMINADOS', 'AUXILIAR DE TERMINADOS'),
        new DataEmployee('Maria Guadalupe Aide', 'Urbina Gaytan', '2018-04-30', 497, 'TERMINADOS', 'AUXILIAR DE TERMINADOS'),
        new DataEmployee('Ramiro Rico', 'Meza', '2014-11-03', 378, 'CHOFER', 'CHOFER'),
        new DataEmployee('Jose Angel', 'Macias Martinez', '2017-09-04', 464, 'CHOFER', 'CHOFER'),
        new DataEmployee('Jorge Alberto', 'Serrano Garcia', '2010-06-21', 264, 'ADMINISTRACION', 'CONTADOR'),
        new DataEmployee('Oscar Estrada', 'Gonzalez', '2010-08-02', 194, 'PRODUCCION', 'COORDINADOR DE PRODUCCION'),
        new DataEmployee('Simon Alejandro', 'Hernandez Corona', '2018-06-25', 370, 'IMPRESION', 'FEEDER'),
        new DataEmployee('Leonardo Daniel', 'Perez Rosales', '2017-07-17', 457, 'IMPRESION', 'FEEDER'),
        new DataEmployee('Jose Alejandro', 'Perez Rosals', '2017-10-24', 473, 'IMPRESION', 'FEEDER'),
        new DataEmployee('Francisco E.', 'Damian Nuñez', '2010-11-24', 274, 'CALIDAD', 'GERENTE DE GESTION DE CALIDAD'),
        new DataEmployee('Mario Estrada', 'Vizcarra', '2001-06-04', 78, 'ADMINISTRACION', 'GERENTE DE PLANTA'),
        new DataEmployee('Sergio Ricardo', 'Jimenez Peña', '2008-01-21', 226, 'VENTAS', 'GERENTE DE VENTAS'),
        new DataEmployee('Bertha Alicia', 'Duran Rosas', '2015-06-01', 106, 'CALIDAD', 'INSPECTOR DE CONTROL DE CALIDAD'),
        new DataEmployee('Brenda Noemi', 'Ascencio Zuñiga', '2010-10-04', 272, 'CALIDAD', 'INSPECTOR DE CONTROL DE CALIDAD'),
        new DataEmployee('Miriam Elizabeth', 'Carrillo Naranjo', '2018-04-23', 495, 'CALIDAD', 'INSPECTOR DE CONTROL DE CALIDAD'),
        new DataEmployee('Acela González', 'Quintero', '2004-04-24', 91, 'INTENDENCIA', 'INTENDENCIA'),
        new DataEmployee('Carlos Javier', 'Andalon Gallo', '2010-01-04', 255, 'ADMINISTRACION', 'MENSAJERO'),
        new DataEmployee('Joel Teran', 'Sandoval', '2017-11-13', 397, 'CORTE', 'OPERADOR DE CORTE'),
        new DataEmployee('Jesus Eduardo', 'Hernandez Florez', '2017-11-02', 474, 'CORTE', 'OPERADOR DE CORTE'),
        new DataEmployee('Norma Leticia', 'Castañeda M.', '2004-11-29', 9, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Jorge Perez', 'Flores', '2008-01-21', 199, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Joel Camarena', 'Hernandez', '2009-06-15', 225, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Raul Zuñiga', 'Cruz', '2001-03-07', 278, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Adrian Ruiz', 'Castillo', '2013-06-24', 349, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Francisco Javier', 'Aguilar Contreras', '2018-01-15', 477, 'PEGADO', 'OPERADOR DE PEGADO'),
        new DataEmployee('Juan Baeza', 'Rojas', '2016-08-24', 36, 'BARNIZ', 'OPERADOR DE PRENSA'),
        new DataEmployee('Jose Ruben', 'Arreola Salcido', '2004-07-26', 94, 'BARNIZ', 'OPERADOR DE PRENSA'),
        new DataEmployee('Jorge Baeza', 'Atilano', '2012-07-16', 142, 'BARNIZ', 'OPERADOR DE PRENSA'),
        new DataEmployee('Roberto Martin', 'Torres', '2013-05-06', 345, 'BARNIZ', 'OPERADOR DE PRENSA'),
        new DataEmployee('Jorge', 'Baez Mendez', '1998-01-12', 4, 'IMPRESION', 'OPERADOR DE PRENSA'),
        new DataEmployee('Sergio Omar', 'Macias J.', '2002-03-05', 55, 'IMPRESION', 'OPERADOR DE PRENSA'),
        new DataEmployee('Jose Angel', 'Macias Jimenez', '2006-07-24', 63, 'IMPRESION', 'OPERADOR DE PRENSA'),
        new DataEmployee('Eduardo Rivas', 'Garcia', '2018-01-22', 420, 'IMPRESION', 'OPERADOR DE PRENSA'),
        new DataEmployee('Oscar Manuel', 'Magallon Hernandez', '2015-04-27', 248, 'TERMINADOS', 'OPERADOR DE PRENSA'),
        new DataEmployee('Iliana Posadas', 'Pontigo', '2015-07-13', 256, 'DISEÑO', 'OPERADOR DE PREPRENSA'),
        new DataEmployee('Alejandro González', 'Martínez', '2003-02-03', 73, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Gerardo Sanchez', 'Alvarez', '2018-01-15', 195, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Nancy V.', 'Guerrero Mendoza', '2010-08-23', 269, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Fernando Michel', 'Vargas', '2013-05-20', 346, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Abby Yahir', 'Hernandez Gutierrez', '2014-04-21', 358, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Alejandro Alvarez', 'Mendoza', '2018-06-25', 374, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Alejandro Castillo', 'Regalado', '2016-08-29', 432, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Fermin Chino', 'Ascencio', '2017-10-23', 472, 'SUAJE', 'OPERADOR DE SUAJE'),
        new DataEmployee('Cintia Yaneth', 'Sandoval Camilo', '2017-02-16', 443, 'ADMINISTRACION', 'RECEPCION'),
        new DataEmployee('Maria de los Angeles', 'Castillo Regalado', '2016-07-28', 421, 'TERMINADOS', 'AUXILIAR DE LINEA'),
        new DataEmployee('Julia Alejandra', 'Amezcua Gutierrez', '2008-03-24', 204, 'ADMINISTRACION', 'RESPONSABLE DE ADMINISTRACION'),
        new DataEmployee('Marco Antonio', 'Castañeda Beltran', '2014-02-04', 252, 'ALMACEN', 'RESPONSABLE DE ALMACEN'),
        new DataEmployee('Jose Roberto', 'Castañeda Beltran', '2018-04-09', 492, 'ALMACEN', 'RESPONSABLE DE ALMACEN'),
        new DataEmployee('Bernardo Olloqui', 'Ceja', '2018-01-08', 476, 'CALIDAD', 'RESPONSABLE DE ASEGURAMIENTO DE CALIDAD'),
        new DataEmployee('Lorena Patricia', 'Zuñiga Sandoval', '2016-07-25', 134, 'ADMINISTRACION', 'RESPONSABLE DE CADENA DE SUMINISTROS'),
        new DataEmployee('Jaime Cesar', 'Sanchez Navarro', '2017-12-11', 475, 'COTIZACIONES', 'RESPONSABLE DE COTIZACIONES'),
        new DataEmployee('Erika Lizette', 'Gutierrez Arce', '2018-10-01', 501, 'DISEÑO', 'RESPONSABLE DE DISEÑO Y PREPRENSA'),
        new DataEmployee('Francisco Javier', 'Lizaola Pozos', '2010-05-10', 207, 'DISEÑO', 'RESPONSABLE DE ESTRUCTURA'),
        new DataEmployee('Salvador Estrada', 'Vizcarra', '2012-05-14', 311, 'MANTENIMIENTO', 'RESPONSABLE DE MANTENIMIENTO'),
        new DataEmployee('Jose Antonio', 'Estrada Vizcarra', '2018-03-14', 490, 'MANTENIMIENTO', 'RESPONSABLE DE MANTENIMIENTO'),
        new DataEmployee('Agueda Mauricio', 'Garcia', '2005-11-21', 133, 'PLACAS', 'RESPONSABLE DE TRANSPORTE DE PLACAS'),
        new DataEmployee('Karla Hernandez', 'Valdivia', '2012-02-06', 300, 'PRODUCCION', 'SUPERVISOR DE PRODUCCION'),
        new DataEmployee('Jorge Alberto', 'Rios Ramirez', '2016-03-08', 192, 'VENTAS', 'VENDEDOR/DUEÑO DE PROCESOS'),
        new DataEmployee('Karina Muñoz', 'Ortiz', '2017-08-22', 463, 'VENTAS', 'VENDEDOR/DUEÑO DE PROCESOS'),
    ] */

}
/* class DataEmployee{
    active;
    activityId;
    admissionDate;
    applyInCheckClock;
    applyInPrompterReport;
    applyInSupervisorReport;
    carrierId;
    createdAt;
    departmentId;
    email;
    imageUrl;
    internalKey;
    lastName;
    name;
    password;
    roleId;
    salt;
    subsidiaryId;
    token;
    transportArrive;
    updatedAt;

    constructor(name, lastName, admissionDate, internalKey, departmentName, jobName ){
        let asd = admissionDate.split('-');
        let currDate = new Date();

        this.active = 1;
        this.activityId = JSON.parse(localStorage.jobsJson)[jobName];
        this.admissionDate = new Date(+asd[0], +asd[1]-1, +asd[2]); 
        this.applyInCheckClock = false;
        this.applyInPrompterReport = false;
        this.applyInSupervisorReport = false;
        this.carrierId = '';
        this.createdAt = currDate;
        this.departmentId = JSON.parse(localStorage.depsJson)[departmentName];
        this.email = `${name.split(' ')[0]}@temp.com`;
        this.imageUrl = '';
        this.internalKey = internalKey;
        this.lastName = lastName;
        this.name = name;
        this.password = '';
        this.roleId = '';
        this.salt = '';
        this.subsidiaryId = '3qcq4VXpRxnHgiz4ISpU';
        this.token = '';
        this.transportArrive = 0;
        this.updatedAt = currDate;
    }
} */

